import { memo, useSyncExternalStore } from 'react';
import { useVideoOverlay } from './useVideoOverlay';
import { timelineActionsStore } from '../../ClipNewTimeline/store/timelineActions';
import FilesInput from '@/components/atoms/inputs/FilesInput/FilesInput';

const VideoOverlayFilesInput = ({ onUploadComplete }: { onUploadComplete: () => void }) => {
  const { isAddingVideo } = useSyncExternalStore(timelineActionsStore.subscribe, timelineActionsStore.getSnapshot);
  const { uploadVideo, acceptedFormats } = useVideoOverlay({ onUploadComplete });

  return (
    <FilesInput
      onFilesUpload={uploadVideo}
      accept={acceptedFormats}
      title={isAddingVideo ? 'Uploading...' : 'Upload Video'}
      variant="button"
      multiple={false}
      iconClassNames={isAddingVideo ? 'animate-spin' : ''}
      icon={isAddingVideo ? 'IconLoader2' : 'IconUpload'}
      isDisabled={isAddingVideo}
    />
  );
};

export default memo(VideoOverlayFilesInput);
